module.exports = __webpack_public_path__ + "static/media/actCardBack2.0a69091d.svg";